import React from "react";
import { Button } from "@mui/material";
import CustomDialog from "./CustomDialog";

export interface ConfirmacionProps {
  mostrarConfirmacion: boolean;
  setMostrarConfirmacion: (valor: boolean) => void;
  titulo: string | React.ReactNode;
  mensaje: string | React.ReactNode;
  onConfirmar: () => void;
}

const DialogoConfirmacion = ({
  mostrarConfirmacion,
  setMostrarConfirmacion,
  titulo,
  mensaje,
  onConfirmar,
}: ConfirmacionProps) => {
  return (
    <CustomDialog
      mostrar={mostrarConfirmacion}
      onClose={() => setMostrarConfirmacion(false)}
      contenido={mensaje}
      acciones={
        <>
          <Button onClick={() => setMostrarConfirmacion(false)}>
            Cancelar
          </Button>
          <Button
            onClick={() => {
              onConfirmar();
              setMostrarConfirmacion(false);
            }}
            data-testid="boton-confirmar"
            autoFocus
          >
            Confirmar
          </Button>
        </>
      }
      titulo={titulo}
      tamanioMaximo="sm"
    />
  );
};

export default DialogoConfirmacion;
